<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="premForm">
        <v-layout row wrap>
          <v-flex row xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 v-if="!newPrem">
            <v-subheader class="queryLabel">{{labels.totTarfRate}}</v-subheader>
            <div class="title">{{premForm.totTarfRate}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field data-vv-scope="premForm" v-num-mask="{negative: true, intScale: 10, decScale: 5}" v-model="premForm.totTarfRate" :label="labels.totTarfRate" :error-messages="errors.collect('premForm.totTarfRate')" data-vv-name="totTarfRate" :data-vv-as="labels.totTarfRate" v-validate="'required'"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="premForm" v-num-mask="{negative: true, intScale: 18, decScale: 2}" v-model="premForm.gap" :label="labels.gap" :error-messages="errors.collect('premForm.gap')" data-vv-name="gap" :data-vv-as="labels.gap" v-validate="'required'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newPrem">
            <cal-picker data-vv-scope = "premForm" :label="labels.effDate" v-model="premForm.effDate" :error-messages="errors.collect('premForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" readonly></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope = "premForm" :label="labels.effDate" v-model="premForm.effDate" :error-messages="errors.collect('premForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope = "premForm" :label="labels.expDate" v-model="premForm.expDate" :error-messages="errors.collect('premForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="premForm.effDate"></cal-picker>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSavePremForm">
        {{newPrem ? 'Save Premium' : 'Update Premium'}}
        <v-icon right>{{newPrem ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data () {
    return {
      premForm: {
        busCls: null,
        tarf: null,
        benefit: null,
        totTarfRate: null,
        effDate: null,
        expDate: null,
        gap: null
      },
      labels: {
        totTarfRate: 'Total Tariff Rate*',
        effDate: 'Effective Date*',
        expDate: 'Expired Date',
        gap: 'Gross Annual Premium*'
      },
      benefitList: [],
      submitting: false,
      newPrem: null
    }
  },
  computed: {
    tarfBenefitMenu() {
      return this.$store.state.parameters.tariff.benefit.menu
    }
  },
  watch: {
    'ids.totTarfRate': function(value) {
      if (value !== 'new') {
        this.resetValidator()
        this.resetMessages()
        this.doClearForm()
        this.newPrem = false
        this.fetchForm(value)
      } else {
        this.doClearForm()
        this.resetValidator()
        this.resetMessages()
        this.newPrem = true
      }
    }
  },
  methods: {
    async fetchForm(totTarfRate) {
      const apiURI = this.tarfBenefitMenu.tarfPrem
      const expand = {
        busCls: this.ids.busCls,
        tarf: this.ids.tarf,
        benefit: this.ids.benefit,
        totTarfRate: parseFloat(totTarfRate),
        effDate: new Date(this.ids.premEffDate)
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.premForm.busCls = data.tarfPrem.busCls
          this.premForm.tarf = data.tarfPrem.tarf
          this.premForm.benefit = data.tarfPrem.benefit
          this.premForm.totTarfRate = formatDisplayNumber(data.tarfPrem.totTarfRate)
          this.premForm.effDate = data.tarfPrem.effDate
          this.premForm.expDate = data.tarfPrem.expDate
          this.premForm.gap = formatDisplayNumber(data.tarfPrem.gap)
          this.menu = extractMenu(result.data._links)
        }
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.premForm.busCls = this.ids.busCls
      this.premForm.tarf = this.ids.tarf
      this.premForm.benefit = this.ids.benefit
      this.premForm.totTarfRate = null
      this.premForm.effDate = null
      this.premForm.expDate = null
      this.premForm.gap = null
    },
    doSavePremForm() {
      this.resetMessages()
      this.$validator.validateAll('premForm').then(result => {
        if (result) {
          if (this.newPrem) {
            this.doCreatePremForm()
          } else {
            this.doUpdatePremForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreatePremForm() {
      const apiURI = this.tarfBenefitMenu.tarfPremCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            totTarfRate: removeFormatNumber(this.premForm.totTarfRate),
            effDate: this.premForm.effDate,
            expDate: this.premForm.expDate,
            gap: removeFormatNumber(this.premForm.gap)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 6)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doUpdatePremForm() {
      const apiURI = this.menu.tarfPremUpdate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: this.ids.benefit,
            totTarfRate: removeFormatNumber(this.premForm.totTarfRate),
            effDate: this.premForm.effDate,
            expDate: this.premForm.expDate,
            gap: removeFormatNumber(this.premForm.gap)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab', 6)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  mounted() {
    if (this.newPrem) {
      this.doClearForm()
    }
  },
  props: {
    ids: {
      type: Object,
      default() {
        return {
          busCls: null,
          tarf: null,
          benefit: null,
          benEffDate: null,
          seqNo: null,
          factEffDate: null,
          rateEffDate: null,
          fact1: null,
          fact2: null,
          fact3: null,
          fact4: null,
          fact5: null,
          fact6: null,
          fact1Desc: null,
          fact2Desc: null,
          fact3Desc: null,
          fact4Desc: null,
          fact5Desc: null,
          fact6Desc: null,
          totTarfRate: null,
          premEffDate: null
        }
      }
    }
  },
  mixins: [
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
